import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-1af9f778"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modern-form-container" };
const _hoisted_2 = { class: "form-card" };
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"header-icon\" data-v-1af9f778><svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1af9f778><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-1af9f778></path><polyline points=\"14,2 14,8 20,8\" data-v-1af9f778></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-1af9f778></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-1af9f778></line><polyline points=\"10,9 9,9 8,9\" data-v-1af9f778></polyline></svg></div>", 1);
const _hoisted_5 = { class: "form-title" };
const _hoisted_6 = { class: "form-subtitle" };
const _hoisted_7 = { class: "card-body" };
const _hoisted_8 = { class: "form-grid" };
const _hoisted_9 = { class: "input-group full-width" };
const _hoisted_10 = { class: "input-group full-width" };
const _hoisted_11 = {
    key: 0,
    class: "vat-info"
};
const _hoisted_12 = { class: "info-item" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M9,12l2,2 4,-4" })
], -1));
const _hoisted_14 = {
    key: 0,
    class: "info-item error"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "15",
        y1: "9",
        x2: "9",
        y2: "15"
    }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "9",
        y1: "9",
        x2: "15",
        y2: "15"
    })
], -1));
const _hoisted_16 = {
    key: 0,
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("polyline", { points: "20,6 9,17 4,12" }, null, -1));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = {
    key: 1,
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("line", {
    x1: "15",
    y1: "9",
    x2: "9",
    y2: "15"
}, null, -1));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("line", {
    x1: "9",
    y1: "9",
    x2: "15",
    y2: "15"
}, null, -1));
const _hoisted_23 = [
    _hoisted_20,
    _hoisted_21,
    _hoisted_22
];
const _hoisted_24 = { class: "help-section" };
const _hoisted_25 = { class: "help-header" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M9,9a3,3,0,1,1,6,0c0,2-3,3-3,3" }),
    /*#__PURE__*/ _createElementVNode("line", {
        x1: "12",
        y1: "17",
        x2: "12.01",
        y2: "17"
    })
], -1));
const _hoisted_27 = {
    href: "mailto:commercial@ficos.com",
    class: "contact-link"
};
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M7 17L17 7" }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M7 7h10v10" })
], -1));
const _hoisted_29 = {
    key: 0,
    class: "vat-checking-overlay"
};
const _hoisted_30 = { class: "vat-checking-modal" };
const _hoisted_31 = { class: "modal-content" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "loading-spinner" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "spinner-ring" }, [
        /*#__PURE__*/ _createElementVNode("div"),
        /*#__PURE__*/ _createElementVNode("div"),
        /*#__PURE__*/ _createElementVNode("div"),
        /*#__PURE__*/ _createElementVNode("div")
    ])
], -1));
const _hoisted_33 = { class: "modal-header" };
const _hoisted_34 = { class: "modal-title" };
const _hoisted_35 = { class: "modal-subtitle" };
const _hoisted_36 = { class: "security-notice" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M9 12l2 2 4-4" })
], -1));
const _hoisted_38 = {
    key: 1,
    class: "banner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_select = _resolveComponent("hit-select");
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_banner = _resolveComponent("hit-banner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.vat_form_vat_number')), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.vat_form_select_country_in_which_your_company_is_based')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_hit_form, {
                    name: "CheckVatForm",
                    value: _ctx.objectFormData,
                    validations: _ctx.validations,
                    "force-cancel-button-hidden": true,
                    "force-save-button-hidden": true
                }, {
                    default: _withCtx(({ formData, validationState }) => [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_hit_select, {
                                    name: "country",
                                    class: "modern-input",
                                    value: formData.country,
                                    "label-fields": _ctx.getDesignationForCurrentLocale,
                                    options: _ctx.countries,
                                    clearable: false,
                                    label: _ctx.t('admin-ui.country'),
                                    "validation-state": validationState.country,
                                    filterable: true,
                                    onChange: _ctx.onChangeCountry
                                }, null, 8, ["value", "label-fields", "options", "label", "validation-state", "onChange"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_hit_input, {
                                    name: "vatNumber",
                                    class: "modern-input",
                                    value: formData.vatNumber,
                                    "validation-state": validationState.vatNumber,
                                    label: _ctx.t('admin-ui.vat_number'),
                                    onInput: _ctx.onChangeVatNumber
                                }, null, 8, ["value", "validation-state", "label", "onInput"]),
                                (_ctx.selectedCountry)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _hoisted_13,
                                            _createElementVNode("span", null, _toDisplayString(_ctx.selectedCountry.vat_length) + " " + _toDisplayString(_ctx.t('admin-ui.vat_form_required_vat_number_length')), 1)
                                        ]),
                                        (_ctx.vatErrorMessage)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _hoisted_15,
                                                _createElementVNode("span", null, _toDisplayString(_ctx.vatErrorMessage), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_ctx.objectFormData.vatNumber)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["info-item", {
                                                        valid: _ctx.objectFormData.vatNumber.length ===
                                                            _ctx.selectedCountry.vat_length,
                                                        invalid: _ctx.objectFormData.vatNumber.length !==
                                                            _ctx.selectedCountry.vat_length,
                                                    }])
                                            }, [
                                                (_ctx.objectFormData.vatNumber.length ===
                                                    _ctx.selectedCountry.vat_length)
                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                                                    : (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_23)),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.objectFormData.vatNumber.length) + "/" + _toDisplayString(_ctx.selectedCountry.vat_length) + " " + _toDisplayString(_ctx.t('admin-ui.vat_form_vat_number_length')), 1)
                                            ], 2))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["value", "validations"]),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("h3", null, _toDisplayString(_ctx.t('admin-ui.vat_form_country_not_listed')), 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.t('admin-ui.vat_form_send_email_to_our_sales_department')), 1),
                    _createElementVNode("a", _hoisted_27, [
                        _createTextVNode(_toDisplayString(_ctx.t('admin-ui.contact_us')) + " ", 1),
                        _hoisted_28
                    ])
                ])
            ])
        ]),
        (_ctx.isCheckingVatApi)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.t('admin-ui.stepper_checking_vat')), 1),
                            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.t('admin-ui.your_vat_number_is_checked')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.vat-verification-security')), 1)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_hit_banner, {
                    "show-animation": _ctx.showAnimationBanner,
                    onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.closeBanner()))
                }, {
                    "dynamic-content": _withCtx(() => [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.textBanner), 1)
                    ]),
                    _: 1
                }, 8, ["show-animation"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
